import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const useOuterClickNotifier = (onOuterClick, innerRef) => {
  useEffect(() => {
    const handleClick = e => {
      if (innerRef.current && !innerRef.current.contains(e.target)) onOuterClick(e);
    };

    if (innerRef.current) {
      document.addEventListener('click', handleClick);
    }

    return () => document.removeEventListener('click', handleClick);
  }, [onOuterClick, innerRef]);
};

const TaskDropdownListComponent = props => {
  const innerRef = useRef(null);

  useOuterClickNotifier(() => _.invoke(props, 'close'), innerRef);

  const childWithRef = React.cloneElement(props.children, { innerRef });

  const isOpen = _.isBoolean(props.isOpen) ? props.isOpen : true;

  return <div ref={innerRef}>{isOpen && childWithRef}</div>;
};

TaskDropdownListComponent.propTypes = {
  children: PropTypes.shape({}),
  close: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
  isOpen: PropTypes.bool,
};

export default TaskDropdownListComponent;
